import { parseISO } from 'date-fns'

/**
 * Cross-browser method for getting milliseconds until a future time
 * from a formatted date string
 * @param {string} time - the future time
 * @param {number} minPeriod - minimum time to return
 * @return {number}
 */
export default function getPeriod({ time, minPeriod = 60000 }) {
  const futureTime = parseISO(time).getTime()
  const now = Date.now()
  let newPeriod = futureTime - now
  if (newPeriod < minPeriod) newPeriod = minPeriod
  return newPeriod
}
